// extracted by mini-css-extract-plugin
export default {"general":"map_general__pB6cO","mapsContainer":"map_mapsContainer__crzdN","mapContainer":"map_mapContainer__0j7jp","map":"map_map__UpJeB","text":"map_text__5p5Cn"};